import React, { useState, useEffect } from "react";
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ls from "local-storage";
import PageNotFound from '../FallBackUI/PageNotFound';
import Barcode from "react-barcode";
import printJS from 'print-js'
import Loading from "../../Component/Loading/Loading";
import moment from 'moment';


const GatePassPrint = (props) => {
    const history = useHistory();

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const userDetails = ls.get('userDetails');
    const successData = useSelector(state => state.LoginReducer.payload);
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false)
    const [carDetails, setCarDetails] = useState("")
    const [loading, setLoading] = useState(true);
    const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
    const { id } = props.location.state;

    useEffect(() => {
        fetchCarDetails()
    }, [])


    async function fetchCarDetails() {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,

        };
        const state = API.post('cardetailsinfo/condition', request);
        state.then(res => {
            setLoading(false);
            if (res.data.success === true) {
                setCarDetails(res.data.data[0]);
                setLoading(false);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }




    const config = {
        background: "#fff",
        displayValue: false,
        marginTop: "10px",
        marginBottom: "10px",
        fontOptions: "italic",
        width: 2,
        heigth: 1
    };

    const printPage = () => {
        console.log("print")
        // props.toggle()
        printJS({
            printable: "gatepass-Print",
            type: 'html',
            targetStyles: ['*'],
            //   header: 'Car Details'
        })
    }

    function formatTime(value) {
        if (!value) {
            return '';
        }
        let local = ""
        let offset = ""
        local = new Date(value);
        offset = local.getTimezoneOffset();
        value = new Date(local.getTime() - offset * 60000);
        value = moment(value).format('MMMM D, YYYY hh:mm A')
        return value;
    }

    return (
        <div>
            {loading ? <Loading /> :
                <main id="main" class="inner-page">
                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div id="historyPage" class="historyPage">
                            <div class="container" >
                                <div class="lotfeeblock col-lg-12">
                                    <div >
                                        <div className="Header-Gate">
                                            <h2 className="">South chicago auto auction , llc</h2>
                                        </div>
                                        <div className="subheader-gatepass">
                                            <h4 className="">Gate pass</h4>
                                        </div>
                                        <div className="layout">
                                            <div className="image-code">
                                                <div className="car-gatepass">
                                                    <img src={carDetails.image} class="carImg" alt="..." />
                                                    {/* <h5> {carDetails.year} {carDetails.make} {carDetails.model} </h5> */}
                                                </div>
                                                <div className="Details-gatepass">
                                                    <p>Bill of sale #: <b>{carDetails.bill_of_sale_id}</b> </p>
                                                    <p>Sale Date: <b>{formatTime(carDetails.sold_date)}</b> </p>
                                                    <p>Buyer Name: <b>{carDetails.buyerName}</b> </p>
                                                    <p>VIN #: <b>{carDetails.vin_no}</b> </p>
                                                    <p>Year: <b>{carDetails.year}</b> </p>
                                                    <p>Make: <b>{carDetails.make}</b> </p>
                                                    <p>Model: <b>{carDetails.model}</b> </p>

                                                </div>
                                            </div>

                                            <div className="Name-gatepass">
                                                <p>Sign Name: _______________________</p>
                                                <p>Print Name: ______________________<span>CLERK _________________</span></p>
                                            </div>
                                            <div className="gatepass-code">
                                                {carDetails.gatepass_code === null || carDetails.gatepass_code === "null" || carDetails.gatepass_code === "" ? "" :
                                                    <>
                                                        {carDetails.gatepass_code === null || carDetails.gatepass_code === "null" || carDetails.gatepass_code === "" ? "" :
                                                            <div className="">
                                                                <Barcode value={carDetails.gatepass_code} {...config} />
                                                            </div>
                                                        }
                                                        *{carDetails.gatepass_code}*
                                                    </>}
                                                <h6 className="gatepass">Thank you so much for your Business! We will be gald to sell your next car!.
                                                    We Highly recomended to Scan the Gatepass to verify.</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="footer-gatepass">
                                        <button class="cta-btns" onClick={() => history.goBack()}> Cancel</button>
                                        <button class="cta-btns" onClick={printPage}> Print</button>
                                    </div>
                                </div>

                                 {/*  duplicationgatepasss*/}
                             <div className="duplicationgatepasss">
                                    <div id="gatepass-Print" >
                                        <div className="Header-Gate2">
                                            <h2 className="">South chicago auto auction , llc</h2>
                                        </div>
                                        <div className="subheader-gatepass2">
                                            <h4 className="">Gate pass</h4>
                                        </div>
                                        <div className="layout">
                                            <div className="image-code2">
                                                <div className="car-gatepass">
                                                    <img src={carDetails.image} class="carImg2" alt="..." />
                                                    {/* <h5> {carDetails.year} {carDetails.make} {carDetails.model} </h5> */}
                                                </div>
                                                <div className="Details-gatepass">
                                                    <p>Bill of sale #: <b>{carDetails.bill_of_sale_id}</b> </p>
                                                    <p>Sale Date: <b>{formatTime(carDetails.sold_date)}</b> </p>
                                                    <p>Buyer Name: <b>{carDetails.buyerName}</b> </p>
                                                    <p>VIN #: <b>{carDetails.vin_no}</b> </p>
                                                    <p>Year: <b>{carDetails.year}</b> </p>
                                                    <p>Make: <b>{carDetails.make}</b> </p>
                                                    <p>Model: <b>{carDetails.model}</b> </p>
                                                </div>
                                            </div>
                                            <div className="Name-gatepass">
                                                <p>Sign Name: _____________________</p>
                                                <p>Print Name: ____________________ </p>
                                                <p>CLERK _________________</p>
                                            </div>
                                            <div className="gatepass-code">
                                                {carDetails.gatepass_code === null || carDetails.gatepass_code === "null" || carDetails.gatepass_code === "" ? "" :
                                                    <>
                                                        {carDetails.gatepass_code === null || carDetails.gatepass_code === "null" || carDetails.gatepass_code === "" ? "" :
                                                            <div className="">
                                                                <Barcode value={carDetails.gatepass_code} {...config} />
                                                            </div>
                                                        }
                                                        *{carDetails.gatepass_code}*
                                                    </>}
                                                <h6 className="gatepass">*** Thank you so much for your suppourt! See you for your next purchase!.
                                                    We Highly recomended to keep photo ID of the person who is picking up. ***</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            
                        </div>}
                </main>
            }
        </div>
    );
};

export default GatePassPrint